import React, { PropsWithChildren } from "react";
import Header from "layout/header";
import Footer from "layout/footer";
import { useLayoutContext } from "layout/layout-provider";
import "./page.css";
import Scribe from "components/scribe";
import useIsPc from "hooks/useIsPc";
import useIsTablet from "hooks/useIsTablet";
import {useScribeContext} from "../contexts/scribe/scribe-provider";
import AnimatedAccessories from "../components/accessories/AnimatedAccessories";
import QRCodeAccessories from "../components/scribe/qr-code-accessories";

const Page: React.FC<PropsWithChildren> = ({ children }) => {
  const { headerHidden, footerHidden, scribeHidden } = useLayoutContext();
  const isPc = useIsPc();
  const isTablet = useIsTablet();
    const { switchToQrCodeScribe} = useScribeContext();


  return (
    <div className="relative overflow-hidden width-100 height-100">
      {!headerHidden && (
        <div className="absolute top-0 width-100 flex justify-center">
          <Header />
        </div>
      )}
      <div className="flex height-100 width-100 justify-center align-center">
        {children}
      </div>
      {!footerHidden && (
        <div className="absolute bottom-0 width-100 origin-bottom flex justify-center">
          <Footer />
        </div>
      )}
      {isPc && !scribeHidden && (
       <>
           <div className="absolute right-0 bottom-0 width-30 max-width-500-px height-100">
               <Scribe
                   canBeClicked={!switchToQrCodeScribe}
               />
           </div>
           <div className="absolute left-0 bottom-0 width-30 max-width-500-px height-100 ">
               <QRCodeAccessories
               />
           </div>
       </>
      )}
      {isTablet && (
        <Scribe />
      )}
    </div>
  );
};

export default Page;
